module.exports = __webpack_public_path__ + "static/media/rocket.f10e19bb.svg";